// extracted by mini-css-extract-plugin
export default {"footerHelper":"Company_footerHelper__6TKLd"};